import React from "react";
import styled from "styled-components";

const GlobalStyleds = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: column;
    height: 600px;

    @media all and (max-width:479px) {
        width: 40%;
        height: 60vw;
    }
`;

const ImageContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    width: 350px;
    height: 275px;
    background-color: #fff;
    border-radius: 10px;

    @media all and (max-width:479px) {
        width: 100%;
        height: 60%;
    }
`;

const ImageBox = styled.div`
    width: 300px;
    height: 200px;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    background-image: ${({ imageUrl }) => `url(${imageUrl})`};
    
    @media all and (max-width:479px) {
        width: 100%;
        height: 100%;
        background-image: ${({ imageUrl }) => `url(${imageUrl})`};
            background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    }
`;

const InfoBox = styled.div`
    margin-top: 20px;
    display: flex;
    gap: 10px;

    @media all and (max-width:479px) {
        margin-top: 5%;
        gap: 2%;
        width: 100%;
        display: flex;
        justify-content: center;
        text-align: center;
    }
`;

const StyledSpan = styled.span`
    font-size: 16px;
    font-weight: normal;

    @media all and (max-width:479px) {
        font-size: 0.5rem;
    }
`;

function DetailImageBox({ pokemonData }) {
    const Height = parseFloat((pokemonData.size.height / 10).toFixed(1));
    const Weight = parseFloat((pokemonData.size.weight / 10).toFixed(1));

    return (
        <GlobalStyleds>
            <ImageContainer>
                <ImageBox imageUrl={pokemonData.image} />
            </ImageContainer>

            {pokemonData.backImage && (
                <ImageContainer>
                    <ImageBox imageUrl={pokemonData.backImage} />
                    <InfoBox>
                        <StyledSpan>키 : {Height}m</StyledSpan>
                        <StyledSpan>몸무게 : {Weight}kg</StyledSpan>
                    </InfoBox>
                </ImageContainer>
            )}
        </GlobalStyleds>
    );
}

export default DetailImageBox;
